<template>
    <div class="page" id="players">
        <header class="pageHeader">
            <fade-image src="assets/headers/players.png" />
        </header>

        <div id="scroller" class="small">
            <div class="pageHeaderIntro">
                <h1>Players</h1>
                <img
                    class="icon"
                    src="~@/assets/icons/profile-white.svg"
                    style="width: 50px; margin-top: -2px"
                />
            </div>

            <empty-placeholder class="mt20" v-if="players.length == 0">
                TIP: This is where your Player accounts will appear giving you access to their
                bookings, lesson records and other account details.
            </empty-placeholder>

            <h2 class="title">Current players:</h2>

            <player-list v-if="players.length > 0" :players="players" />

            <div v-if="!$store.state.playersLoaded">
                <pre-loader-item mb="10" v-for="n in 5" :key="n" />
            </div>

            <span class="info" v-else-if="players.length == 0">You currently have no players.</span>

            <router-link class="button dark mb30" :to="{ name: 'proInvite' }"
                >Invite new Player <plus-icon class="icon"
            /></router-link>
            <h2 class="title">Pending Players</h2>
            <empty-placeholder class="mt20" v-if="pendingPlayers.length == 0">
                TIP: You’re invited Players will appear here until they have accepted your
                invitation to join.
            </empty-placeholder>
            <player-list
                v-if="pendingPlayers.length > 0"
                :pending="true"
                :show-search="false"
                :players="pendingPlayers"
            />
        </div>
    </div>
</template>

<script>
import EmptyPlaceholder from "@/components/App/empty-placeholder";
import { PlusIcon } from "vue-feather-icons";
import PlayerList from "@/components/Pro/Player/player-list.vue";
import FadeImage from "@/components/App/fade-image";
import PreLoaderItem from "@/components/App/Pre-loader-item";
export default {
    name: "players",
    components: {
        EmptyPlaceholder,
        PreLoaderItem,
        FadeImage,
        PlayerList,
        PlusIcon,
    },
    created() {
        this.$store.dispatch("getPendingPlayers");
        this.$store.dispatch("getPlayers");
    },
    computed: {
        pendingPlayers() {
            return this.$store.state.pending_players;
        },
        players() {
            return this.$store.state.players;
        },
    },
};
</script>

<style lang="scss" scoped>
#players {
    #scroller .title {
        margin-bottom: 20px;
    }
}
</style>
